import { SymbolCard } from '@components/ArtBoard/SettingsSidebar/components/SymbolLibrary/components/SymbolCard'
// biome-ignore lint/suspicious/noShadowRestrictedNames: Symbol is a domain component name
import { Symbol } from '@components/ArtBoard/SettingsSidebar/components/SymbolLibrary/components/Symbols/components/Symbol'
import { selectLibraryItem } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { COLOR_BLUE } from '@/constants/constants'
import type { AppState } from '@/types'
import css from './SymbolOverlay.module.scss'

const SymbolOverlay: React.FC = () => {
  const id = useSelector<AppState, string | null>(
    ({ artboard }) => artboard.dragAndDrop.dragged.id
  )
  const fromLibrary = useSelector<AppState, boolean>(({ artboard }) =>
    Boolean(artboard.dragAndDrop.dragged.data?.library)
  )
  const item = useSelector((state: AppState) =>
    fromLibrary && id ? (selectLibraryItem('symbol', id)(state) ?? null) : null
  )
  const color = useSelector(
    migrationProjectSelector.getHexForUI(
      item?.data.color?.hexCode ?? COLOR_BLUE
    )
  )

  if (!id) {
    return null
  }

  if (fromLibrary) {
    return (
      <div className={css.container}>
        {item && (
          <SymbolCard
            id={item.id}
            index={0}
            overlay
            title={item.data.title}
            color={color}
            visual={item.data.visual}
          />
        )}
      </div>
    )
  }

  return (
    <div className={css.container}>
      <Symbol id={id} index={0} overlay isLast={false} />
    </div>
  )
}

export default SymbolOverlay
